export default __webpack_public_path__ + "static/media/pic1.476ced91.jpg";